var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{style:({ background: _vm.$vuetify.theme.themes.dark.background })},[_c('router-view',{staticClass:"appBar",attrs:{"name":"appBar"}}),_c('router-view',{staticClass:"sideBar",attrs:{"name":"sideBar"}}),_c('router-view',{staticClass:"sideBarRight",attrs:{"name":"sideBarRight"}}),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }